/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';


const Launcher = ({
  handlerSetComponents, components, id,
}) => {
  const initialState = {
    type: 'Launcher',
    findCategory: [],
    quantity: 3,
    noLoadMore: true,
    isNews: false,
  };

  const [limit] = useState(20);
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const getCategories = () => {
    getPostsByType('section')
      .then(({ posts }) => {
        if (posts) {
          const cats = [];
          posts.forEach(post => cats.push(post.postCategory[0]));
          setCategories(cats);
        }
      })
      .catch(err => console.log(err));
  };

  const setLimitHandler = (e) => {
    const { name, value } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: Number(value),
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const showMoreHandler = (e, bool) => {
    const { name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: bool,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };


  const setCategoriesHandler = (cat) => {
    const postIndex = selectedCategories.findIndex(set => set === cat);
    const componentObj = {
      id,
      component: state,
    };
    let newState = {};

    if (postIndex === -1) {
      newState = {
        ...state,
        findCategory: [...selectedCategories, cat],
      };
      setSelectedCategories([...selectedCategories, cat]);
      setState(newState);
    } else {
      const newCategories = selectedCategories;
      newCategories.splice(postIndex, 1);
      newState = {
        ...state,
        findCategory: [...newCategories],
      };
      setSelectedCategories([...newCategories]);
      setState(newState);
    }
    componentObj.component = newState;

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);

    const { component } = components[componentIndex];

    setIndex(componentIndex);

    // Check if we are reading a component already done or if we are creating a new one
    getCategories();
    if (component) {
      setState(component);
      setSelectedCategories(component.findCategory);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <div>
      {
        categories && categories.length > 0 && (
          <div>
            <div className="ml-12 mr-2 rounded-lg">
              <p className="font-americaMonoBold text-xs uppercase py-1 bg-greyFilter rounded-t-lg pl-5 mt-8px mb-0">Post categories</p>
              <div className="rounded-b-lg mb-2 pt-0 overflow-auto h-32 bg-greyFilterItems pt-1 pb-1/2">
                {
                  categories.map(category => (
                    <div key={category} className="text-black text-black font-americaMonoRegular outline-none w-full pl-6 mb-0" onClick={() => setCategoriesHandler(category)}>
                      {category}
                    </div>
                  ))
                }
              </div>
              {
                selectedCategories && selectedCategories.length > 0 && (
                  <div className="text-black">
                    <p className="font-americaMonoBold text-xs text-white uppercase py-1 bg-greyFilter rounded-t-lg pl-5 mt-8px mb-0">Selected categories</p>
                    <div className="rounded-b-lg mb-2 pt-0 overflow-auto bg-greyFilterItems pt-1 pb-1/2">
                      {selectedCategories.map(category => (
                        <div key={category} className="text-black text-black font-americaMonoRegular outline-none w-full pl-6 mb-0">
                          {category}
                          <span className="font-icon icon-close-btn1 pl-1 text-xs text-black" onClick={() => setCategoriesHandler(category)} />
                        </div>
                      ))}
                    </div>
                  </div>
                )
              }

            </div>
            <div className="flex flex-row ml-10 items-center justify-between bg-greyFilter rounded-br-lg">
              <div className="my-2 pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular">
                Number of items
                <select name="quantity" id="quantity" onChange={setLimitHandler} value={state.quantity} className="ml-1">
                  {
                    Array.from(Array(limit + 1)).map((_, ind) => (
                      <option value={ind} key={ind}>
                        {' '}
                        {ind}
                        {' '}
                      </option>
                    ))
                  }
                </select>
              </div>
              <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center">
                Show load more
                <label className="switch mb-0 pb-0 h-6 ml-1">
                  <input
                    name="noLoadMore"
                    checked={state.noLoadMore}
                    onChange={e => showMoreHandler(e, !state.noLoadMore)}
                    type="checkbox"
                    id="switch-button"
                  />
                  <div className="switch-slider btn-yn switch-round" />
                </label>
              </div>
              <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center">
                Show as news layout
                <label className="switch mb-0 pb-0 h-6 ml-1">
                  <input
                    name="isNews"
                    checked={!state.isNews}
                    onChange={e => showMoreHandler(e, !state.isNews)}
                    type="checkbox"
                    id="switch-button"
                  />
                  <div className="switch-slider btn-yn switch-round" />
                </label>
              </div>
              <div />
            </div>
          </div>

        )
      }
    </div>
  );
};

Launcher.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
};


export default Launcher;
